import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

// project imports
import useAuth from 'hooks/useAuth';

// ==============================|| AUTH GUARD ||============================== //

/**
 * Authentication guard for routes
 * @param {PropTypes.node} children children element/node
 */
const AuthGuard = ({ children }) => {
    const { isLoggedIn, user } = useAuth();
    const navigate = useNavigate();

    useEffect(() => {
        if (!isLoggedIn) {
            navigate('login', { replace: true });
        } else if (user && user.role === 'ROLE_HOUSEMAID') {
            // Rediriger automatiquement les femmes de ménage vers leur planning,
            // sauf si elles accèdent aux paramètres utilisateur
            const currentPath = window.location.pathname;
            const allowedPaths = [
                '/app/housemaid/planning',
                '/user/account-profile/profile'
            ];

            if (!allowedPaths.some(path => currentPath.startsWith(path))) {
                navigate('/app/housemaid/planning', { replace: true });
            }
        }
    }, [isLoggedIn, user, navigate]);

    return children;
};

AuthGuard.propTypes = {
    children: PropTypes.node
};

export default AuthGuard;
